module.exports = __webpack_public_path__ + "static/assets/3a62bf87d6785cbceede3811763609af.svg";